import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const ScreenHairColorStyles = styled(OnboardingPage)`
  .local-title {
    margin: 20px auto 40px;
  }
`;
